import common from './common.js';
import transition from './transition.js';

import header from './header.js';

import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

import '../scss/style.scss';

const app = {
  init() {
    transition.init();
    common.init();
    header.init();
  }
};

app.init();